import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  SectionHero,
  SectionWhoWeAre,
  SectionOurStory,
  SectionVisionMission,
  SectionWhatWeDo,
  SectionOurClients,
  SectionWhyChooseUs,
  SectionContactUs,
} from "./sections";
import { Footer } from "./components/Footer";

export const Beranda = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <SectionHero />
      <div className="w-full border-t border-slate-200" />
      <SectionWhoWeAre />
      <div className="w-full border-t border-slate-200" />
      <SectionOurStory />
      <div className="w-full border-t border-slate-200" />
      <SectionVisionMission />
      <div className="w-full border-t border-slate-200" />
      <SectionWhatWeDo />
      <div className="w-full border-t border-slate-200" />
      <SectionOurClients />
      <div className="w-full border-t border-slate-200" />
      <SectionWhyChooseUs />
      <div className="w-full border-t border-slate-200" />
      <SectionContactUs />
      <Footer />
    </div>
  );
};
